import { cn } from '@lib/utils';
import { createFileRoute } from '@tanstack/react-router';
import { AnimatePresence, motion } from 'framer-motion';
import { LoginForm } from '../../components/auth/login-form';
import { Steps } from '../../components/auth/steps';
import logo from '@assets/logo.svg';
import loginBackground from '@assets/admin/login/login-img.png';

const fadeAnimationVariants = {
  hidden: { opacity: 0, y: -100 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 100 },
};

function LoginComponent() {
  return (
    <div className="relative flex h-screen w-screen">
      <div className="flex h-full w-full items-center">
        <div className="max-h-full w-1/3 overflow-y-auto p-6">
          <div className="mx-auto max-w-[400px]">
            <div className="mb-8 flex flex-col items-center gap-4 text-center">
              <img src={logo} alt="logo" className="h-24" />
              <h1 className="text-left text-xl font-bold text-black">
                Para entrar na CantinaPay,
                <br /> informe seus dados abaixo
              </h1>
            </div>
            <div>
              <AnimatePresence mode="wait">
                <motion.div key="resume" initial="hidden" animate="visible" exit="exit" variants={fadeAnimationVariants}>
                  <LoginForm />
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>
        <div className={cn('relative flex h-full flex-1 flex-col items-center justify-center gap-6')}>
          <div className="absolute inset-0 left-0 top-0 z-0 h-full w-screen bg-gradient-to-tr from-orange-500 to-orange-300" />
          <img src={loginBackground} alt="login-background" className="relative z-10 max-h-[55%] w-[600px] object-contain" />
          <Steps />
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/(auth)/login')({
  component: LoginComponent,
});